var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMagGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7437 10.9828C18.7437 15.4203 15.1907 18.9656 10.8718 18.9656C6.55299 18.9656 3 15.4203 3 10.9828C3 6.54523 6.55299 3 10.8718 3C15.1907 3 18.7437 6.54523 18.7437 10.9828ZM18.3432 18.9613C16.3952 20.8235 13.7655 21.9656 10.8718 21.9656C4.86749 21.9656 0 17.0484 0 10.9828C0 4.91716 4.86749 0 10.8718 0C16.8762 0 21.7437 4.91716 21.7437 10.9828C21.7437 13.0402 21.1837 14.9655 20.2092 16.6115L28.1351 23.1625C28.7737 23.6903 28.8635 24.6358 28.3357 25.2743C27.8079 25.9129 26.8624 26.0027 26.2239 25.4749L18.3432 18.9613Z",
    fill: "#0C570C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagGreen);
export default __webpack_public_path__ + "static/media/search-mag-green.ab07d6e067efb59f66d9dd19ac853d87.svg";
export { ForwardRef as ReactComponent };